const defaultState = {
  services: [],
  testimonials: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_CLIENT_TEMPLATES':
      return action.clientTemplates;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/clientTemplates.js